/* global Isotope */
export default () => {
  const library = document.querySelector('[data-material-library]');

  if (library) {

    const filters = document.querySelectorAll('[data-material-library-filter]');

    const selectorNamespace = 'material-selector__';

    const iso = new Isotope('[data-material-library]', {
      itemSelector: '.material-selector__color',
      layoutMode: 'fitRows',
    });

    window.iso = iso;

    filters.forEach((filter) => {
      filter.addEventListener('change', () => {
        const activeFilters = Array.from(filters).filter((el) => el.value !== '');
        iso.arrange({ filter: activeFilters.map((el) => `.${selectorNamespace}${el.value}`).join('') });
      });
    });
  }
};
